export interface IUseOverflowListResult<T> {
  visible: T[];
  hidden: T[];
  remaining: number;
  overflowLabel: string;
}

/** @registry Splits a list at `maxItems` into a visible slice and a hidden tail, and derives the "Show N more" accessible label shared by every capped-list-with-overflow display (AvatarGroup, BadgeShortList, ...). Callers own the trigger element and the disclosure's content layout. */
export const useOverflowList = <T>(
  items: T[],
  maxItems: number,
): IUseOverflowListResult<T> => {
  const visible = items.slice(0, maxItems);
  const hidden = items.slice(maxItems);
  const remaining = hidden.length;
  return {
    visible,
    hidden,
    remaining,
    overflowLabel: `Show ${remaining} more`,
  };
};
